module.exports = __webpack_public_path__ + "static/media/splash_bug.e2403d5a.png";